module.exports = __webpack_public_path__ + "src/img/cookies/cookies-blue-row.ee6a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cookies/cookies-blue-row.jpg
// module id = 246
// module chunks = 0